import { setWorkflowConfigurations } from "@redux/actions/workflows-actions";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { Dispatch } from "redux";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { getWorkflowConfigurationsRequest, updateWorkflowChangeRequestRequest } from "@requests/service-configuration";
import { formatWorkflowConfigurations } from "@formatters/workflows/workflow-configuration-formatter";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";

export const updateWorkflowChangeRequestReduxRequest = (dispatch: Dispatch) => async (
    workflowId: string,
    body: { [key: string]: any },
    changeRequestStatus: ChangeRequestStatusTypes,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): Promise<WorkflowChangeRequest> => {
    const { data, error } = await updateWorkflowChangeRequestRequest(workflowId, body, changeRequestStatus);
    if (data?.transferObject) {
        if (![ChangeRequestStatusTypes.REJECTED, ChangeRequestStatusTypes.APPROVED].includes(changeRequestStatus)) {
            const workflowConfigurationsResponse = await getWorkflowConfigurationsRequest();
            if (workflowConfigurationsResponse.data) {
                const formattedWorkflowConfigurations = formatWorkflowConfigurations(
                    workflowConfigurationsResponse.data,
                    companies,
                    relyingParties
                );
                dispatch(setWorkflowConfigurations(formattedWorkflowConfigurations));
                displaySuccessModal(
                    dispatch,
                    resources.requests.updateWorkflowChangeRequest.success.title,
                    resources.requests.updateWorkflowChangeRequest.success.message
                );
            }
        }
        return data.transferObject;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateWorkflowChangeRequest.error.title,
            resources.requests.updateWorkflowChangeRequest.error.message,
            error,
            null,
            body
        );
    }
    return null;
};